import { render, staticRenderFns } from "./DynamicDetail.vue?vue&type=template&id=6de2fd08&scoped=true"
import script from "./DynamicDetail.vue?vue&type=script&lang=js"
export * from "./DynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetail.vue?vue&type=style&index=0&id=6de2fd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de2fd08",
  null
  
)

export default component.exports